import styles from "../Editor.module.css";
import InputControl from "../../InputControl/InputControl";

function WorkExpBody(props) {
  const workExpPoints = ["Line1", "Line2", "Line3", "Line4"];
  const sections = props.sections;
  return (
    <div className={styles.detail}>
      <div className={styles.row}>
        <InputControl
          label="Title"
          placeholder="Enter title eg. Frontend developer"
          value={props.information[sections.workExp].details[props.activeDetailIndex]?.title}
          // value={values.title}
          onChange={(event) =>
            props.setInformation((prev) => ({ ...prev, 
                [sections.workExp]: {...prev[sections.workExp],
                  details: prev[sections.workExp].details.map((detail, index) =>
                    index === props.activeDetailIndex
                      ? { ...detail, title: event.target.value }
                      : detail
                  ),
                }
            }))
          }
        />
        <InputControl
          label="Company Name"
          placeholder="Enter company name eg. amazon"
          value={props.information[sections.workExp].details[props.activeDetailIndex]?.companyName}
          // value={values.companyName}
          onChange={(event) =>
            props.setInformation((prev) => ({ ...prev, 
                [sections.workExp]: {...prev[sections.workExp],
                  details: prev[sections.workExp].details.map((detail, index) =>
                    index === props.activeDetailIndex
                      ? { ...detail, companyName: event.target.value }
                      : detail
                  ),
                }
            }))
          }
        />
      </div>
      <div className={styles.row}>
        {/* <InputControl
          label="Certificate Link"
          placeholder="Enter certificate link"
          value={values.certificationLink}
          onChange={(event) =>
            props.setInformation((prev) => ({
              ...prev,
              certificationLink: event.target.value,
            }))
          }
        /> */}
        <InputControl
          label="Location"
          placeholder="Enter location eg. Remote"
          value={props.information[sections.workExp].details[props.activeDetailIndex]?.location}
          // value={values.location}
          onChange={(event) =>
            props.setInformation((prev) => ({ ...prev, 
                [sections.workExp]: {...prev[sections.workExp],
                  details: prev[sections.workExp].details.map((detail, index) =>
                    index === props.activeDetailIndex
                      ? { ...detail, location: event.target.value }
                      : detail
                  ),
                }
            }))
          }
        />
      </div>
      <div className={styles.row}>
        <InputControl
          label="Start Date"
          type="date"
          placeholder="Enter start date of work"
          value={props.information[sections.workExp].details[props.activeDetailIndex]?.startDate}
          // value={values.startDate}
          onChange={(event) =>
            props.setInformation((prev) => ({ ...prev, 
                [sections.workExp]: {...prev[sections.workExp],
                  details: prev[sections.workExp].details.map((detail, index) =>
                    index === props.activeDetailIndex
                      ? { ...detail, startDate: event.target.value }
                      : detail
                  ),
                }
            }))
          }
        />
        <InputControl
          label="End Date"
          type="date"
          placeholder="Enter end date of work"
          value={props.information[sections.workExp].details[props.activeDetailIndex]?.endDate}
          // value={values.endDate}
          onChange={(event) =>
            props.setInformation((prev) => ({ ...prev, 
                [sections.workExp]: {...prev[sections.workExp],
                  details: prev[sections.workExp].details.map((detail, index) =>
                    index === props.activeDetailIndex
                      ? { ...detail, endDate: event.target.value }
                      : detail
                  ),
                }
            }))
          }
        />
      </div>

      <div className={styles.column}>
        <label>Enter work description</label>
        {workExpPoints.map((line, index)=>(
          <InputControl
            placeholder={line}
            value={props.information[sections.workExp].details[props.activeDetailIndex]?.points ? props.information[sections.workExp].details[props.activeDetailIndex].points[index] : ""}
            // value={values.points ? values.points[index] : ""}
            onChange={(event) => 
              // handlePointUpdate(event.target.value, index)
              props.setInformation((prev) => ({ ...prev, 
                [sections.workExp]: {...prev[sections.workExp],
                  details: prev[sections.workExp].details.map((detail, detailIndex) => {
                    if (detailIndex === props.activeDetailIndex) {
                      return {
                        ...detail,
                        points: detail.points.map((point, pointIndex) => {
                          if (pointIndex === index) {
                            return event.target.value; // Update the point value
                          }
                          return point;
                        }),
                      };
                    }
                    return detail;
                  }),
                }
            }))
            }
          />
        ))}
      </div>
    </div>
  )
}

export default WorkExpBody